/* Plentum "Can my dog eat this?" checker. Progressive enhancement over server-rendered Liquid. */
(function (root) {
  'use strict';

  /* ---------- search core (pure, testable in node) ---------- */
  function norm(s) {
    return String(s || '').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/['’`]/g, '')
      .replace(/[^a-z0-9 ]+/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }
  function stem(w) {
    if (w.length > 4 && /ies$/.test(w)) return w.slice(0, -3) + 'y';
    if (w.length > 4 && /(ches|shes|sses|xes|zes)$/.test(w)) return w.slice(0, -2);
    if (w.length > 3 && /oes$/.test(w)) return w.slice(0, -2);
    if (w.length > 3 && /s$/.test(w) && !/(ss|us|is)$/.test(w)) return w.slice(0, -1);
    return w;
  }
  function tokens(s) { return norm(s).split(' ').filter(Boolean).map(stem); }

  /* Damerau-Levenshtein (optimal string alignment) with early exit */
  function dist(a, b, max) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    var d = [], i, j;
    for (i = 0; i <= la; i++) { d[i] = [i]; }
    for (j = 0; j <= lb; j++) { d[0][j] = j; }
    for (i = 1; i <= la; i++) {
      var rowMin = max + 1;
      for (j = 1; j <= lb; j++) {
        var c = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        var v = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + c);
        if (i > 1 && j > 1 && a.charCodeAt(i - 1) === b.charCodeAt(j - 2) && a.charCodeAt(i - 2) === b.charCodeAt(j - 1)) {
          v = Math.min(v, d[i - 2][j - 2] + 1);
        }
        d[i][j] = v;
        if (v < rowMin) rowMin = v;
      }
      if (rowMin > max) return max + 1;
    }
    return d[la][lb];
  }
  function allowed(len) { return len <= 3 ? 0 : len <= 6 ? 1 : 2; }

  function buildIndex(foods) {
    return foods.map(function (f, idx) {
      var names = [f.name].concat(f.synonyms || []);
      var fields = names.map(function (n, k) {
        return { text: norm(n), toks: tokens(n), weight: k === 0 ? 1 : 0.92 };
      });
      return { idx: idx, food: f, fields: fields, catTok: tokens(f.category) };
    });
  }

  /* score one query token against one field's tokens; returns 0..1 */
  function tokenScore(q, fieldToks) {
    var best = 0;
    for (var i = 0; i < fieldToks.length; i++) {
      var t = fieldToks[i];
      if (t === q) { best = Math.max(best, 1); continue; }
      if (q.length >= 2 && t.indexOf(q) === 0) { best = Math.max(best, 0.85 + 0.1 * (q.length / t.length)); continue; }
      if (q.length >= 4 && t.indexOf(q) > 0) { best = Math.max(best, 0.55); }
      var m = allowed(Math.min(q.length, t.length));
      if (m > 0) {
        var dd = dist(q, t, m);
        if (dd <= m) best = Math.max(best, 0.8 - 0.15 * dd);
        /* typo within a prefix of a longer word (as-you-type) */
        if (t.length > q.length && q.length >= 4) {
          var dp = dist(q, t.slice(0, q.length), 1);
          if (dp <= 1) best = Math.max(best, 0.62 - 0.1 * dp);
        }
      }
    }
    return best;
  }

  function search(index, query, limit) {
    var qt = tokens(query);
    if (!qt.length) return [];
    var qn = norm(query);
    var out = [];
    for (var n = 0; n < index.length; n++) {
      var e = index[n], best = 0;
      for (var f = 0; f < e.fields.length; f++) {
        var fld = e.fields[f], total = 0, ok = true;
        for (var k = 0; k < qt.length; k++) {
          var s = tokenScore(qt[k], fld.toks);
          if (s === 0) { ok = false; break; }
          total += s;
        }
        if (!ok) continue;
        var sc = (total / qt.length) * fld.weight;
        if (fld.text === qn) sc += 0.5;
        else if (fld.text.indexOf(qn) === 0) sc += 0.2;
        /* fewer extra words in the field = tighter match */
        sc -= Math.max(0, fld.toks.length - qt.length) * 0.02;
        if (sc > best) best = sc;
      }
      if (best >= 0.5) out.push({ food: e.food, score: best });
    }
    out.sort(function (a, b) { return b.score - a.score || a.food.name.length - b.food.name.length || (a.food.name < b.food.name ? -1 : 1); });
    return out.slice(0, limit || 8);
  }

  var api = { norm: norm, tokens: tokens, dist: dist, buildIndex: buildIndex, search: search };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
  root.PlentumFoodSearch = api;

  /* ---------- UI ---------- */
  if (typeof document === 'undefined') return;

  var SVGNS = 'http://www.w3.org/2000/svg';
  var ORDER = ['safe', 'small-amounts', 'caution', 'toxic'];
  var LABEL = { 'safe': 'Safe', 'small-amounts': 'Safe in small amounts', 'caution': 'Use caution', 'toxic': 'Toxic' };
  var SHORT = { 'safe': 'Safe', 'small-amounts': 'Small amounts', 'caution': 'Caution', 'toxic': 'Toxic' };
  var SINGULAR = { 'pothos': 1 };
  function isPlural(name) {
    var w = name.toLowerCase().split(/[ ,]+/).pop();
    return /s$/.test(w) && !/(ss|us|is)$/.test(w) && !SINGULAR[w];
  }
  /* the verdict line: a full sentence that names the food */
  function verdictLine(f) {
    var n = cap(inline(f.name)), be = isPlural(f.name) ? 'are' : 'is';
    if (f.verdict === 'safe') return ['Yes.', n + ' ' + be + ' safe for dogs.'];
    if (f.verdict === 'small-amounts') return ['Yes, in small amounts.', n + ' ' + be + ' fine as an occasional treat.'];
    if (f.verdict === 'caution') return ['Use caution.', n + ' can be risky for dogs.'];
    return ['No.', n + ' ' + be + ' toxic to dogs.'];
  }
  var CYCLE = ['grapes', 'chocolate', 'peanut butter', 'cheese', 'blueberries', 'avocado', 'onions', 'watermelon'];
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function catLabel(c) { return c.replace(/, ([a-z]+) and /, ', $1, and '); }
  function icon(id, cls) {
    var s = document.createElementNS(SVGNS, 'svg');
    s.setAttribute('class', 'cmde-ico' + (cls ? ' ' + cls : '')); s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false');
    var u = document.createElementNS(SVGNS, 'use'); u.setAttribute('href', '#cmde-i-' + id); s.appendChild(u);
    return s;
  }
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'class') n.className = attrs[k];
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function dot(v) { return el('span', { class: 'cmde-dot cmde-dot--' + v, 'aria-hidden': 'true' }); }
  function host(url) { try { return new URL(url).hostname.replace(/^www\./, ''); } catch (e) { return url; } }
  /* "Cheddar Cheese" -> "cheddar cheese" for use inside a sentence; keeps acronyms like MSG */
  function inline(name) { return name.split(' ').map(function (w) { return /[A-Z].*[A-Z]/.test(w) ? w : w.toLowerCase(); }).join(' '); }

  function init() {
    var app = document.querySelector('[data-cmde]');
    if (!app) return;
    app.classList.add('is-ready');
    var url = app.getAttribute('data-foods-url');
    var input = app.querySelector('[data-cmde-input]');
    var list = app.querySelector('[data-cmde-results]');
    var status = app.querySelector('[data-cmde-status]');
    var result = app.querySelector('[data-cmde-card]');
    var index = null, byId = {}, active = -1, shown = [];

    function load() {
      var pre = root.CMDE_FOODS;
      var p = pre ? Promise.resolve(pre) : fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      return p.then(function (foods) {
        index = buildIndex(foods);
        foods.forEach(function (f) { byId[f.id] = f; });
      });
    }

    /* ----- animated placeholder: types a food, pauses, erases ----- */
    var cyc = { i: 0, t: null, on: !reduced };
    function typeLoop() {
      if (!cyc.on) return;
      var full = 'Try ' + CYCLE[cyc.i % CYCLE.length], n = 4;
      (function typeChar() {
        if (!cyc.on) return;
        input.placeholder = full.slice(0, n);
        if (n < full.length) { n++; cyc.t = setTimeout(typeChar, 70); return; }
        cyc.t = setTimeout(function erase() {
          if (!cyc.on) return;
          if (n > 4) { n--; input.placeholder = full.slice(0, n); cyc.t = setTimeout(erase, 28); return; }
          cyc.i++; typeLoop();
        }, 1800);
      })();
    }
    function stopCycle() { cyc.on = false; clearTimeout(cyc.t); input.placeholder = 'Try grapes, chocolate, or cheese'; }

    /* ----- results list ----- */
    function closeList() { list.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; app.classList.remove('is-open'); }
    function renderList(results, q) {
      list.textContent = ''; shown = results; active = -1;
      if (!results.length) {
        list.appendChild(el('li', { class: 'cmde-opt cmde-opt--none', role: 'presentation', text: 'No match for “' + q + '”. Try another word, or call your vet if your dog already ate it.' }));
      }
      results.forEach(function (r, i) {
        var f = r.food;
        var li = el('li', { class: 'cmde-opt', role: 'option', id: 'cmde-opt-' + i, 'aria-selected': 'false', 'data-id': f.id }, [
          el('span', { class: 'cmde-opt__txt' }, [el('span', { class: 'cmde-opt__name', text: f.name }), el('span', { class: 'cmde-opt__cat', text: catLabel(f.category) })]),
          el('span', { class: 'cmde-vtag cmde-vtag--' + f.verdict }, [dot(f.verdict), SHORT[f.verdict]]),
          icon('enter', 'cmde-opt__key')
        ]);
        li.addEventListener('mousedown', function (e) { e.preventDefault(); choose(f.id, true); });
        li.addEventListener('mousemove', function () { if (active !== i) setActive(i, true); });
        list.appendChild(li);
      });
      list.hidden = false; input.setAttribute('aria-expanded', 'true'); app.classList.add('is-open');
      if (results.length) setActive(0, true);
      status.textContent = results.length ? results.length + (results.length === 1 ? ' result' : ' results') + '. Use the arrow keys to move through them.' : 'No results.';
    }
    function setActive(i, noScroll) {
      var opts = list.querySelectorAll('[role=option]');
      if (!opts.length) return;
      active = (i + opts.length) % opts.length;
      for (var k = 0; k < opts.length; k++) opts[k].setAttribute('aria-selected', k === active ? 'true' : 'false');
      input.setAttribute('aria-activedescendant', opts[active].id);
      if (!noScroll) opts[active].scrollIntoView({ block: 'nearest' });
    }

    /* ----- verdict card ----- */
    function fact(ic, title, text) {
      if (!text || /^nothing (else )?needed/i.test(text)) return null;
      return el('div', { class: 'cmde-fact' }, [el('h3', { class: 'cmde-fact__h' }, [icon(ic), title]), el('p', { text: text })]);
    }
    function meter(v) {
      var m = el('div', { class: 'cmde-meter', role: 'img', 'aria-label': 'Answer: ' + LABEL[v] + ', ' + (ORDER.indexOf(v) + 1) + ' of 4 on a scale from safe to toxic' });
      var row = el('div', { class: 'cmde-meter__bar' }), lab = el('div', { class: 'cmde-meter__labels', 'aria-hidden': 'true' });
      ORDER.forEach(function (x) {
        row.appendChild(el('span', { class: x === v ? 'is-on' : '' }));
        lab.appendChild(el('span', { class: x === v ? 'is-on' : '', text: SHORT[x] }));
      });
      m.appendChild(row); m.appendChild(lab);
      return m;
    }
    function renderCard(f, focusIt, scroll) {
      var tox = f.verdict === 'toxic', line = verdictLine(f), name = inline(f.name);
      var card = el('article', { class: 'cmde-card cmde-card--' + f.verdict, 'aria-labelledby': 'cmde-card-h' });
      var main = el('div', { class: 'cmde-card__main' }, [
        el('h2', { class: 'cmde-card__h', id: 'cmde-card-h', tabindex: '-1' }, [el('span', { class: 'cmde-card__yn', text: line[0] }), ' ', line[1]]),
        el('p', { class: 'cmde-card__why', text: f.why }),        f.keywordAnswer ? el('section', { class: 'cmde-fact', 'data-keyword-repoint': f.keywordAnswer.id }, [
          el('h3', { class: 'cmde-fact__h', text: f.keywordAnswer.heading }),
          el('p', { text: f.keywordAnswer.text })
        ]) : null,
        meter(f.verdict)
      ]);
      var head = el('div', { class: 'cmde-card__head' }, [main]);
      if (tox) {
        var ateBtn = el('button', { type: 'button', class: 'cmde-btn cmde-btn--light' }, [icon('phone'), 'My dog already ate ' + name]);
        ateBtn.addEventListener('click', function () { openAte(f); });
        head.appendChild(el('aside', { class: 'cmde-alert', 'aria-label': 'What to do now' }, [
          el('p', { class: 'cmde-alert__h' }, [icon('alert'), 'Act now, even if your dog seems fine.']),
          el('p', { class: 'cmde-alert__p', text: 'Signs can take hours to appear. Call your vet or ASPCA Animal Poison Control right away.' }),
          ateBtn,
          el('a', { class: 'cmde-alert__tel', href: 'tel:+18884264435' }, ['Call (888) 426-4435', icon('arrow')])
        ]));
      }
      card.appendChild(head);
      var facts = tox
        ? [fact('signs', 'Warning signs', f.signs), fact('todo', 'What to do', f.todo), fact('serve', 'How to serve it', f.serve)]
        : [fact('serve', f.verdict === 'caution' ? 'How to serve it safely' : 'How to serve it', f.serve), fact('signs', 'Warning signs', f.signs), fact('todo', 'If your dog has a problem', f.todo)];
      facts = facts.filter(Boolean);
      var factBox = el('div', { class: 'cmde-facts cmde-facts--' + facts.length + (tox ? '' : ' cmde-facts--side') }, facts);
      if (tox) card.appendChild(factBox); else if (facts.length) head.appendChild(factBox);
      var src = el('p', { class: 'cmde-card__src' }, ['Sources: ']);
      var seen = {};
      (f.sources || []).filter(function (u) { var h = host(u); if (seen[h]) return false; seen[h] = 1; return true; }).forEach(function (u, i) {
        if (i) src.appendChild(document.createTextNode(', '));
        src.appendChild(el('a', { href: u, rel: 'noopener', target: '_blank', text: host(u) }));
      });
      var acts = el('div', { class: 'cmde-card__acts' });
      if (!tox) {
        var ate2 = el('button', { type: 'button', class: 'cmde-link' }, ['My dog ate too much', icon('arrow')]);
        ate2.addEventListener('click', function () { openAte(f); });
        acts.appendChild(ate2);
      }
      var again = el('button', { type: 'button', class: 'cmde-link' }, ['Check another food', icon('search')]);
      again.addEventListener('click', function () { input.value = ''; input.focus(); input.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); });
      var copy = el('button', { type: 'button', class: 'cmde-link' }, ['Copy link', icon('link')]);
      copy.addEventListener('click', function () {
        var link = location.href.split('#')[0] + '#' + f.id;
        var done = function () { copy.firstChild.nodeValue = 'Link copied'; setTimeout(function () { copy.firstChild.nodeValue = 'Copy link'; }, 2200); };
        if (navigator.clipboard) navigator.clipboard.writeText(link).then(done, function () { location.hash = f.id; }); else location.hash = f.id;
      });
      acts.appendChild(again); acts.appendChild(copy);
      card.appendChild(el('div', { class: 'cmde-card__foot' }, [src, acts]));

      result.textContent = ''; result.appendChild(card); result.hidden = false;
      if (focusIt) card.querySelector('#cmde-card-h').focus({ preventScroll: true });
      if (scroll !== false) {
        var y = result.getBoundingClientRect().top + window.pageYOffset - 24;
        window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
      }
    }

    function choose(id, push) {
      var f = byId[id]; if (!f) return;
      stopCycle();
      input.value = f.name; closeList();
      renderCard(f, true);
      if (push && history.replaceState) history.replaceState(null, '', '#' + id);
    }

    /* ----- "My dog already ate it" panel ----- */
    var ate = app.querySelector('[data-cmde-ate]');
    var ateOpener = null;
    function openAte(f) {
      ateOpener = document.activeElement;
      ate.querySelector('[data-ate-what]').textContent = f ? inline(f.name) : 'something';
      var specific = ate.querySelector('[data-ate-specific]');
      var sp = f && f.todo && f.todo.indexOf('426-4435') < 0 && !/^nothing/i.test(f.todo) ? f.todo : '';
      specific.textContent = sp; specific.hidden = !sp;
      ate.hidden = false;
      document.documentElement.classList.add('cmde-lock');
      ate.querySelector('.cmde-call').focus();
    }
    function closeAte() {
      ate.hidden = true;
      document.documentElement.classList.remove('cmde-lock');
      if (ateOpener && ateOpener.focus) ateOpener.focus();
    }
    app.querySelectorAll('[data-open-ate-generic]').forEach(function (b) { b.addEventListener('click', function () { openAte(null); }); });
    ['[data-ate-close]', '[data-ate-x]', '[data-ate-close-scrim]'].forEach(function (s) { ate.querySelector(s).addEventListener('click', closeAte); });
    ate.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeAte(); return; }
      if (e.key === 'Tab') {
        var f = ate.querySelectorAll('a[href], button:not([disabled])');
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    /* ----- search input ----- */
    var timer = null;
    input.addEventListener('focus', function () { if (cyc.on) stopCycle(); });
    input.addEventListener('input', function () {
      var q = input.value;
      if (!index) return;
      if (!q.trim()) { closeList(); status.textContent = ''; return; }
      clearTimeout(timer);
      timer = setTimeout(function () { renderList(search(index, q, 8), q); }, 40);
    });
    function submit() {
      if (active >= 0 && shown[active]) { choose(shown[active].food.id, true); return; }
      if (index && input.value.trim()) { var r = search(index, input.value, 8); if (r.length) choose(r[0].food.id, true); else renderList(r, input.value); }
      else input.focus();
    }
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden && input.value.trim() && index) renderList(search(index, input.value, 8), input.value); else setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Escape') { closeList(); }
    });
    input.addEventListener('blur', function () { setTimeout(closeList, 150); });
    app.querySelector('[data-cmde-form]').addEventListener('submit', function (e) { e.preventDefault(); submit(); });

    /* ----- browse: category index, answer filter, and a short preview of each category ----- */
    var PREVIEW = 3;
    var groups = Array.prototype.slice.call(app.querySelectorAll('[data-cat]')).map(function (g) {
      var tiles = Array.prototype.slice.call(g.querySelectorAll('[data-food]'));
      var name = (g.querySelector('.cmde-group__h') || {}).textContent || '';
      var more = el('div', { class: 'cmde-more' });
      var btn = el('button', { type: 'button', class: 'cmde-btn cmde-btn--line' });
      more.appendChild(btn); g.appendChild(more);
      var rec = { el: g, slug: g.getAttribute('data-cat'), tiles: tiles, name: name, more: more, btn: btn, open: false };
      btn.addEventListener('click', function () { rec.open = true; apply(); });
      return rec;
    });
    var catNow = 'all', vNow = 'all';
    var catBtns = Array.prototype.slice.call(app.querySelectorAll('[data-cat-btn]'));
    var vBtns = Array.prototype.slice.call(app.querySelectorAll('[data-v-btn]'));
    function apply() {
      var total = 0;
      groups.forEach(function (g) {
        var match = g.tiles.filter(function (t) { return vNow === 'all' || t.getAttribute('data-v') === vNow; });
        var limit = catNow === 'all' && !g.open ? PREVIEW : Infinity;
        g.tiles.forEach(function (t) { t.hidden = true; });
        match.forEach(function (t, i) { t.hidden = i >= limit; });
        g.el.hidden = !(catNow === 'all' || catNow === g.slug) || !match.length;
        g.more.hidden = match.length <= limit;
        g.btn.textContent = 'Show all ' + match.length + ' in ' + g.name.toLowerCase();
        if (!g.el.hidden) total += match.length;
      });
      return total;
    }
    catBtns.forEach(function (b) { b.addEventListener('click', function () {
      catNow = b.getAttribute('data-cat-btn');
      catBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var n = apply();
      status.textContent = 'Showing ' + n + ' items.';
      var lists = app.querySelector('[data-cmde-lists]');
      window.scrollTo({ top: lists.getBoundingClientRect().top + window.pageYOffset - 120, behavior: reduced ? 'auto' : 'smooth' });
    }); });
    vBtns.forEach(function (b) { b.addEventListener('click', function () {
      vNow = b.getAttribute('data-v-btn');
      vBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      status.textContent = 'Showing ' + apply() + ' items.';
    }); });
    apply();

    /* server-rendered food links and whole tiles open the answer card */
    app.addEventListener('click', function (e) {
      var t = e.target;
      var a = t.closest && t.closest('[data-show]');
      if (a) { e.preventDefault(); choose(a.getAttribute('data-show'), true); return; }
      var tile = t.closest && t.closest('[data-food]');
      if (tile && !t.closest('a')) choose(tile.id, true);
    });

    var pb = app.querySelector('[data-cmde-print]');
    if (pb) pb.addEventListener('click', function () { window.print(); });

    function fromHash() {
      var id = decodeURIComponent((location.hash || '').slice(1));
      if (id && byId[id]) { stopCycle(); input.value = byId[id].name; renderCard(byId[id], false); }
    }
    window.addEventListener('hashchange', fromHash);

    load().then(function () {
      status.textContent = '';
      if (location.hash && byId[decodeURIComponent(location.hash.slice(1))]) {
        fromHash();
        /* the browser's own jump to the server-rendered #id can land after ours */
        setTimeout(function () { window.scrollTo(0, result.getBoundingClientRect().top + window.pageYOffset - 24); }, 60);
      }
      else if (cyc.on) typeLoop();
    }).catch(function () {
      stopCycle();
      input.placeholder = 'Search is unavailable. Browse the list below.';
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})(typeof window !== 'undefined' ? window : globalThis);
